module.exports = __webpack_public_path__ + "media/images/speaker_1-519478c9b9e834bdc9045006ebd0dc34.svg";